import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Auth0Lock from 'auth0-lock'
import { AUTH_CONFIG } from '../../utils/auth'
import {
  VAULTURE_USERID_KEY,
  VAULTURE_USERNAME_KEY,
  VAULTURE_USER_AVATAR_KEY,
} from '../../utils/constants'

interface Props {
  location: any
}

interface State {
  loggedIn: any
}

class Lock extends Component<Props, State> {
  lock = new Auth0Lock(AUTH_CONFIG.clientId, AUTH_CONFIG.domain, {
    auth: {
      responseType: 'token id_token',
      sso: false,
    },
    container: AUTH_CONFIG.container,
    languageDictionary: {
      title: 'Vaulture',
    },
    theme: {
      logo: 'logo2.png',
      primaryColor: '#FBBD08',
    },
  })

  constructor(props: any) {
    super(props)
    this.state = { loggedIn: false }
    this.onAuthenticated = this.onAuthenticated.bind(this)

    this.onAuthenticated()
  }

  onAuthenticated() {
    this.lock.on('authenticated', authResult => {
      let expiresAt = JSON.stringify(
        authResult.expiresIn * 1000 + new Date().getTime(),
      )
      localStorage.setItem('access_token', authResult.accessToken)
      localStorage.setItem('id_token', authResult.idToken)
      localStorage.setItem('expires_at', expiresAt)

      // TODO: move these elsewhere..
      localStorage.setItem(VAULTURE_USERID_KEY, authResult.idTokenPayload.sub)
      // TODO: auth0 typing is missing profile pic
      localStorage.setItem(
        VAULTURE_USER_AVATAR_KEY,
        //@ts-ignore
        authResult.idTokenPayload.picture,
      )
      localStorage.setItem(
        VAULTURE_USERNAME_KEY,
        //@ts-ignore
        authResult.idTokenPayload.given_name,
      )

      this.setState({ loggedIn: true })
    })
  }

  componentDidMount() {
    // Avoid showing Lock when hash is parsed.
    if (!/access_token|id_token|error/.test(this.props.location.hash)) {
      this.lock.show()
    }
  }

  render() {
    const style = { marginTop: '32px' }

    return !this.state.loggedIn ? (
      <div>
        <div id={AUTH_CONFIG.container} style={style} />
      </div>
    ) : (
      <Redirect
        to={{
          pathname: '/files',
          state: { from: this.props.location },
        }}
      />
    )
  }
}

export default Lock
